import { StartScreenPrompt } from '@openai/chatkit-react'
import { TChatKitConstants, TTranslationFunction } from '../_lib/types'

/**
 * Get localized ChatKit constants for Blog Generator
 * @param t - Translation function from useTranslations('blog-generator')
 * @returns Localized ChatKit constants
 */
export function getChatKitConstants(
  t: TTranslationFunction,
): TChatKitConstants {
  return {
    greeting: t('chatkit_greeting'),
    starterPrompts: [
      {
        label: t('starter-prompts.create-from-topic.label'),
        prompt: t('starter-prompts.create-from-topic.prompt'),
        icon: 'sparkle',
      },
      {
        label: t('starter-prompts.create-from-existing.label'),
        prompt: t('starter-prompts.create-from-existing.prompt'),
        icon: 'book-open',
      },
      {
        label: t('starter-prompts.enable-daily-blog-auto-publishing.label'),
        prompt: t('starter-prompts.enable-daily-blog-auto-publishing.prompt'),
        icon: 'lightbulb',
      },
    ],
    placeholder: t('chatkit_placeholder'),
  }
}
